import { WaveCRDTBridge, type WaveBlock } from "@vida/wave-core";

type Props = {
  currentSeq: number;
  maxSeq: number;
  previewBlocks: WaveBlock[];
  onSeqChange: (seq: number) => void;
};

export function WavePlaybackView({
  currentSeq,
  maxSeq,
  previewBlocks,
  onSeqChange,
}: Props) {
  return (
    <div className="playback-panel">
      <label>
        Playback seq: {currentSeq} / {maxSeq}
        <input
          type="range"
          min={0}
          max={maxSeq}
          value={currentSeq}
          onChange={(e) => onSeqChange(Number(e.target.value))}
        />
      </label>
      <div className="playback-preview">
        {previewBlocks.map((b) => (
          <div key={b.id} className="playback-block">
            <strong>{b.kind}</strong>{" "}
            {b.payload.text ?? b.payload.title ?? b.payload.refTitle ?? ""}
          </div>
        ))}
      </div>
    </div>
  );
}

export function reconstructForPlayback(
  bridge: WaveCRDTBridge,
  baseline: import("@vida/wave-core").WaveDocumentSnapshot,
  ops: import("@vida/wave-core").WaveOpRecord[],
  seq: number,
): WaveBlock[] {
  return bridge.documentAtSeq(baseline, ops, seq).blocks;
}
